export default __webpack_public_path__ + "static/media/MS_864X312.d88b10cd.svg";